import axios from 'axios';

import {
  ArticleGetRequest,
  ArticleGetResponse,
  ArticleParams,
  ArticlePostRequest,
  ArticlePostResponse,
  ArticlePutRequest,
  ArticlePutResponse,
} from '../model/articleModel';

export const ArticleApi = {
  post: (data: ArticlePostRequest) => {
    return axios.post<ArticlePostResponse>('/api/articles', data);
  },
  put: (params: ArticleParams, data: ArticlePutRequest) => {
    return axios.put<ArticlePutResponse>(`/api/articles/${params.id}`, data);
  },
  delete: (params: ArticleParams, data: any) => {
    return axios.delete(`/api/articles/${params.id}`, data);
  },
  getOne: (params: ArticleParams) => {
    return axios.get<ArticleGetResponse>(`/api/articles/${params.id}`);
  },
  getAll: (params: ArticleGetRequest) => {
    return axios.get<ArticleGetResponse[]>('/api/articles/admin/list', {
      params: params,
    });
  },
};
